import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestTanquesVirtuais({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'tanquesvirtuais', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteTanquesVirtual({ payload }) {
  try {
    const { idtanquevirtual, params } = payload;

    yield call(api.delete, `tanquesvirtuais/${idtanquevirtual}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(t(e)));
    else toast.error(t(erros));
  }
}

export function* store({ payload }) {
  try {
    const { tanquesvirtual, params } = payload;

    yield call(api.post, 'tanquesvirtuais', tanquesvirtual);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/tanquesvirtuais');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idtanquevirtual } = payload;

    const { data } = yield call(api.get, `tanquesvirtuais/${idtanquevirtual}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { tanquesvirtual, params } = payload;

    yield call(api.put, 'tanquesvirtuais', tanquesvirtual);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/tanquesvirtuais');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'tanquesvirtuais', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest(
    '@tanquesvirtual/TANQUESVIRTUAIS_IN_REQUEST',
    requestTanquesVirtuais
  ),
  takeLatest('@tanquesvirtual/DELETE_TANQUESVIRTUAL', deleteTanquesVirtual),
  takeLatest('@tanquesvirtual/SUCCESS_REMOVE', requestTanquesVirtuais),
  takeLatest('@tanquesvirtual/STORE_TANQUESVIRTUAL', store),
  takeLatest('@tanquesvirtual/FIND_TANQUESVIRTUAL', find),
  takeLatest('@tanquesvirtual/UPDATE_TANQUESVIRTUAL', update),
  takeLatest('@tanquesvirtual/RECORD_FILTERING', applyedFilters),
]);
